/**
 * @generated SignedSource<<c0e244ecec9e8c5cb427755013187a8a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SignalPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type SignalOverviewListItemMedium_Signal$data = {
  readonly descriptionFiles: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly descriptionImages: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly employeeReceiverReceiptsCount: number;
  readonly id: string;
  readonly linkedProducts: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly priority: SignalPriority;
  readonly publishedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  } | null;
  readonly store: {
    readonly employeeCount: number;
  };
  readonly title: string;
  readonly " $fragmentType": "SignalOverviewListItemMedium_Signal";
};
export type SignalOverviewListItemMedium_Signal$key = {
  readonly " $data"?: SignalOverviewListItemMedium_Signal$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalOverviewListItemMedium_Signal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignalOverviewListItemMedium_Signal",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priority",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "publishedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "employeeReceiverReceiptsCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "employeeCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreProduct",
      "kind": "LinkedField",
      "name": "linkedProducts",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "descriptionFiles",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Signal",
  "abstractKey": null
};
})();

(node as any).hash = "6a25aa4623a11ee5c4d4bcd6adc88589";

export default node;
